import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getRequest } from "../../services/apiMethods";
import { isPdfExtensions } from "../../utils/commFunction";

const Accreditations = () => {
  const Navigate = useNavigate();
  const {
    data: accreditationsData,
    error: userError,
    isLoading: userLoading,
  } = useQuery({
    queryKey: ["AccreditationsData"],
    queryFn: () => getRequest(`/accreditation/list`),
  });

  return (
    <div className="my-profile-box-contain">
      <div className="my-profile-box-form">
        <div className="h-100 m-0">
          <div className="form-box-title ">
            <div>
              <h4>Accreditations & Qualifications</h4>
              <p>
             Qualifications are optional but could help you secure more
                business{" "}
              </p>
            </div>
            <button
              className="theme-comm-btn"
              onClick={() => Navigate("/accreditations")}
            >
              Add
            </button>
          </div>
          <div className="portfolio-card-contain">
            <Row>
              {Array.isArray(accreditationsData?.data) &&
              accreditationsData?.data.length > 0 ? (
                <>
                  {accreditationsData?.data.map((val) => {
                    return (
                      <Col
                        lg={4}
                        key={val?._id}
                        onClick={() =>
                          Navigate(`/accreditations?accredtationId=${val?._id}`)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="portfolio-card-box">
                          <img
                            src={
                              isPdfExtensions(val?.cretificate)
                                ? require("../../assets/images/pdfIMG.png")
                                : val?.cretificate ||
                                  require("../../assets/images/dimmy-img.png")
                            }
                          />
                          <h4>{val?.award} </h4>
                          <p>{val?.education}</p>
                        </div>
                      </Col>
                    );
                  })}
                </>
              ) : (
                <Col lg={12}>
                  <div className="text-center">
                    {/* <h4>No data found</h4> */}
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accreditations;
